import { _ } from "i18n";
import type { OptionProps } from "react-select";
import { resolveMediaUrl } from "./mediaUrl.utils";
import type { NetworkSelectOption } from "./networkSelect.utils";

export function NetworkSelectOptionComponent({
	innerRef,
	innerProps,
	data,
	isSelected,
	isDisabled,
	logoBasePath,
}: OptionProps<NetworkSelectOption, true> & { logoBasePath?: string }) {
	const subtitle = buildSubtitle(data);
	const logoSrc = data.logo !== null && logoBasePath !== undefined ? resolveMediaUrl(data.logo, logoBasePath) : data.logo;

	return (
		<div
			ref={innerRef}
			{...innerProps}
			className={`network-select__option${isSelected ? " network-select__option--selected" : ""}${isDisabled ? " network-select__option--disabled" : ""}`}
		>
			<span className={`network-select__checkbox${isSelected ? " network-select__checkbox--checked" : ""}`} aria-hidden="true" />
			<span className="network-select__avatar">
				{logoSrc !== null ? (
					<img src={logoSrc} alt="" className="network-select__logo" />
				) : (
					<span className="network-select__initials">{data.label.slice(0, 2).toUpperCase()}</span>
				)}
			</span>
			<span className="network-select__text">
				<span className="network-select__title">{data.label}</span>
				{subtitle !== null && <span className="network-select__subtitle">{subtitle}</span>}
			</span>
		</div>
	);
}

function buildSubtitle(data: NetworkSelectOption): string | null {
	const parts: string[] = [];

	if (data.country !== null) parts.push(data.country);
	if (data.teamCount > 0) parts.push(`${data.teamCount} ${_("country.selection.network.teamsIncluded")}`);
	if (data.gender !== null) parts.push(data.gender);

	return parts.length > 0 ? parts.join(" • ") : null;
}
